const NotFound = () => {
  return (
    <div className="notFound">
      <h1>Page not found</h1>
    </div>
  );
};

export default NotFound;
